// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1enZ8","errors":"Errors_errors__1MZzM"};